import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Heading, Stack, Box, SegmentGroup, HStack, Text, Textarea, Field,Flex, Spacer, Input, Select, createListCollection, Portal, Button} from '@chakra-ui/react';
import { LuTrash2 as LuRemove, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"
import axios from 'axios';
import PageTitle from 'components/ui/PageTitle';
import PageContent from 'components/ui/PageContent';
import JobStatus from 'components/ui/JobStatus';

function JobsOverviewPage() {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/api/jobs');
        setJobs(response.data);
      } catch (err) {
        console.error('Error fetching jobs', err);
        setError(err.message);
      }
    };

    fetchJobs();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Add this new function before the return statement
  const handleDelete = async (e, jobId) => {
    e.stopPropagation(); // Prevent row click navigation
    try {
      // Remove the deleted job from the state
      setJobs(jobs.filter(job => job.id !== jobId));
      await axios.delete(`/api/jobs/${jobId}`);
    } catch (err) {
      console.error('Error deleting job', err);
      // setError(err.message);
    }
  };

  return(
    <PageContent>
      <PageTitle icon={LuSearchResults} title="Search Results" />

      <Table.Root variant="line" stickyHeader w="100%">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>ID</Table.ColumnHeader>
            <Table.ColumnHeader>Date</Table.ColumnHeader>
            <Table.ColumnHeader>Status</Table.ColumnHeader>
            <Table.ColumnHeader>Program</Table.ColumnHeader>
            <Table.ColumnHeader>Hit Count</Table.ColumnHeader>
            <Table.ColumnHeader>Title</Table.ColumnHeader>
            <Table.ColumnHeader></Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {jobs.map((job, index) => (
            <Table.Row key={job.id} onClick={() => {window.location.href=`/results/${job.id}`}} 
              bg={index % 2 === 0 ? 'gray.subtle' : 'brand.bg'}
              _hover={{ bg: 'brand.100', cursor: 'pointer' }}
              >
                <Table.Cell>{job.id}</Table.Cell>
                <Table.Cell>{new Date(job.date+'Z').toLocaleString()}</Table.Cell>
                <Table.Cell><JobStatus status={job.status} /></Table.Cell>
                <Table.Cell>{job.blast_program}</Table.Cell>
                <Table.Cell>{job.result_count}</Table.Cell>
                <Table.Cell>{job.description}</Table.Cell>
                <Table.Cell  p="0">
                  <Button variant="plain" size="md" maxH="2.2em" maxW="0.1em" color="red" _hover={{ bg: 'brand.subtle' }}
                    onClick={(e) => handleDelete(e, job.id)}
                    aria-label="Delete job"
                  >
                    <LuRemove strokeWidth="2.2"/>
                  </Button>
                </Table.Cell>
              </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

    </PageContent>

  );

  // return (
  //   <div style={{ margin: "2rem" }}>
  //     <h1>Search Results</h1>
  //     <Link to="/">Go to Home</Link><br />
  //     <Link to="/search">Go to Search</Link>

  //     <table style={{ marginTop: "2rem", width: "100%" }}>
  //       <thead>
  //         <tr>
  //           <th>Date</th>
  //           <th>Status</th>
  //           <th>BLAST Program</th>
  //           <th>Title</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {jobs.map((job) => (
  //           <tr key={job.id}>
  //             <td>{new Date(job.date+'Z').toLocaleString()}</td>
  //             <td>{job.status}</td>
  //             <td>{job.blast_program}</td>
  //             <td>{job.description}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>
  //   </div>
  // );
}

export default JobsOverviewPage;